import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { logo } from "../utils/constants";
import SearchBar from "./SearchBar";

const handleClick = () => {
    window.location.pathname = '/';
    document.title = 'Tube US | Boundless Curiosity';
    document.querySelector('meta[property="og:title"]').setAttribute('content', 'Tube US | Boundless Curiosity');
    document.querySelector('meta[name="description"]').setAttribute('content', 'Step into the exciting universe of Tube US, where engaging videos await. Uncover popular creations and experience nonstop fun. Tune in now on Tube US.');
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Step into the exciting universe of Tube US, where engaging videos await. Uncover popular creations and experience nonstop fun. Tune in now on Tube US.');
};

const Navbar = () => (
  <Stack
    direction="row"
    alignItems="center"
    p={2}
    sx={{
      position: "sticky",
      background: "#5484ed",
      top: 0,
      justifyContent: "space-between"
    }}
  >
    <Link style={{ display: "flex", alignItems: "center" }} onClick={handleClick}>
      <img src={logo} alt="logo" height={45} />
    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar;
